"use strict";

exports.__esModule = true;
exports.default = void 0;

var _popover = require("./popover");

var _popover2 = require("../../directives/popover");

var _plugins = require("../../utils/plugins");

var components = {
  BPopover: _popover.default
};
var plugins = {
  BPopoverDirectivePlugin: _popover2.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components,
    plugins: plugins
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/popover/index.js
// module id = pDyP
// module chunks = 14